import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY || "";

export function RecaptchaWrapper({ children }: { children: React.ReactNode }) {
  if (!SITE_KEY) return <>{children}</>;

  return (
    <GoogleReCaptchaProvider reCaptchaKey={SITE_KEY} useEnterprise>
      {children}
    </GoogleReCaptchaProvider>
  );
}
